var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.format === 'sendMessage')?_c('div',{staticClass:"choice-message choice-message-center"},[_c('p',{staticClass:"send-chat-message"},[_vm._v("Send besked")]),_c('p',{staticClass:"chat-message",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}})]):_c('div',{staticClass:"choice-message",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }